import React, { Component } from 'react';
import { Route, Switch, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';

import {useMobile} from './store/utility';

import Layout from './hoc/Layout/Layout';
import Profile from './containers/Profile/Profile';
import Home from './containers/Home/Home';
import Schedule from './containers/Schedule/Schedule';
import Auth from './containers/Auth/Auth';
import Assist from './containers/Assist/Assist';
import About from './containers/About/About';
import CalendarManagement from './containers/CelendarManagement/CalendarManagement';
import AppointmentManagement from './containers/AppointmentManagement/AppointmentManagement';
import RelationManagement from './containers/RelationManagement/RelationManagement';

// import FAQs from './components/StaticPage/FAQs';
// import Blogs from './containers/Blogs/Blogs';
import Logout from './containers/Auth/Logout/Logout';
import NotFound from './components/NotFound/NotFound';
import * as actions from './store/actions/index';

// component pages
import PrivacyPolicy from './components/StaticPage/PrivacyPolicy';
import TermOfServices from './components/StaticPage/TermOfServices';

// alert system
import Alert from 'react-s-alert';

// cookie
// import Cookies from 'js-cookie';

import classes from './App.css';

class App extends Component {

    componentDidMount () {
        this.props.onTryAutoSignup();
        // if (Cookies.get('has_shown_covid19_notification')!=='true'){
        //     Alert.info('COVID-19: Stay at Home, Bend the Curve and Call Your Friends');
        //     Cookies.set('has_shown_covid19_notification', 'true');
        // }
    }

    render () {
        let routes = (
            <Switch>
                <Route path="/schedule/:calendar_id" component={Schedule} key="schedule"/>
                <Route path="/view-my-calendar/:calendar_id" component={Schedule} key="view-my-calendar"/>
                <Route path="/auth/:action?" component={Auth} />
                <Route path="/calendar-management/:calendar_id" component={CalendarManagement} />
                <Route path="/relation" component={RelationManagement} />
                <Route path="/appointment-management/:appointment_id" component={AppointmentManagement} />
                <Route path="/assist" component={Assist} />
                {/* <Route path="/blog" component={Blogs} /> */}
                <Route path="/about" component={About} />
                {/* <Route path="/faq" component={FAQs} /> */}
                <Route path="/logout" component={Logout} />
                <Route path="/profile" component={Profile} />
                <Route path="/" exact component={Home} />
                <Route path="/privacy-policy" component={PrivacyPolicy} />
                <Route path="/term-of-services" component={TermOfServices} />
                {/* home page */}
                <Route path="/home" component={Home} />
                <Route path="/" exact component={Home} />
                {/* Catch all unknow paths */}
                <Route path="*" component={NotFound} />
            </Switch>
        );

    // determine which app style to use
    let appStyle;
    if (useMobile()===true) {
        appStyle = classes.AppMobile;
    }
    else {
        appStyle = classes.App;
    }

    return (
      <div className={appStyle}>
        <Layout>
            {routes}
        </Layout>
        <Alert stack={{limit: 1}} timeout={3000} position="bottom" effect="scale" />
      </div>
    );
  }
}

const mapStateToProps = state => {
    return {
        isAuthenticated: state.auth.token !== null
    };
};

const mapDispatchToProps = dispatch => {
    return {
        onTryAutoSignup: () => dispatch( actions.authCheckState() )
    };
};

export default withRouter( connect( mapStateToProps, mapDispatchToProps )( App ) );



// WEBPACK FOOTER //
// ./src/App.js